import React, { FC } from 'react';
import styled from './InvoiceChangeInvoiceStatusModal.module.css';
import Button from '../../../../components/Button/Button';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal';

interface Props {
    onAccept: () => void;
    onClose: () => void;
    numberOfCompaniesMarked: number;
}

const InvoiceChangeInvoiceStatusToInvoicedModal: FC<Props> = ({ onAccept, onClose, numberOfCompaniesMarked }) => {
    const { t } = useTranslation();

    return (
        <Modal
            title={t('invoicedChangeStatusToInvoicedTitle')}
            subtitle={t('invoicedChangeStatusToInvoicedText', { numberOfCompaniesMarked: numberOfCompaniesMarked })}
            className={styled.Modal}
        >
            <div className={styled.Options}>
                <Button variant="Primary" onClick={onClose}>
                    {t('buttonNo')}
                </Button>
                <Button variant="Outline" onClick={onAccept}>
                    {t('buttonYes')}
                </Button>
            </div>
        </Modal>
    );
};

export default InvoiceChangeInvoiceStatusToInvoicedModal;
